/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBandcamp = createReactComponent("outline", "brand-bandcamp", "IconBrandBandcamp", [["path", { "d": "M8.5 6h13.5l-7 12h-13z", "key": "svg-0" }]]);

export { IconBrandBandcamp as default };
//# sourceMappingURL=IconBrandBandcamp.mjs.map
